import styled from 'styled-components';

export const StyledButtonSpan = styled.span`
  flex-grow: 0;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;`;

export const Button = styled.button`
  border: unset;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 1em;
  border-radius: 10px;
  background-color: #198754;
  cursor: pointer;
  width: 100%;
  @media (max-width: 576px) {
    margin: 1em 0;
  }
  @media (min-width: 576px) {
    margin: 1em auto;
  }`;
